import { GuildAvatar } from '../../shared/ui/guild-avatar.js';

export function ProfileAvatar({
  name,
  logoUrl,
  frameId,
  frameArt,
  animated,
  size = 44,
}: {
  readonly name: string;
  readonly logoUrl: string | null;
  readonly frameId: string;
  readonly frameArt?: string | undefined;
  readonly animated: boolean;
  readonly size?: number;
}): React.ReactElement {
  return (
    <span
      className="profile-avatar"
      data-frame={frameId}
      data-art={Boolean(frameArt)}
      data-animated={animated}
    >
      <GuildAvatar
        name={name}
        logoUrl={logoUrl ?? undefined}
        frameId={frameId}
        frameArt={frameArt}
        size={size}
      />
      <span className="profile-avatar__effects" aria-hidden="true">
        <span />
        <span />
        <span />
        <span />
      </span>
    </span>
  );
}
